import { render } from "./ArrowLeftSvg.vue?vue&type=template&id=2f39da2a"
import script from "./ArrowLeftSvg.vue?vue&type=script&lang=js"
export * from "./ArrowLeftSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__